import slugify from 'slugify';

import { arrayToObject } from 'app/utils/objects';

import { endpoints, getDatabaseData } from './index';

const decorateAndOrderResultsByDate = results => {
  const orderedResults = Object.values(results)
    .map(post => {
      const slug = slugify(post.title);

      return { ...post, slug: slug.toLowerCase() };
    })
    .sort((a, b) => Date.parse(a.date) - Date.parse(b.date))
    .reverse();

  const orderedObject = arrayToObject(orderedResults, 'id');

  return orderedObject;
};

const getAllBlogPosts = async () => {
  const response = await getDatabaseData(endpoints.BLOG).then(data => data);
  const orderedResponse = decorateAndOrderResultsByDate(response);

  return orderedResponse;
};

export default { getAllBlogPosts };



// WEBPACK FOOTER //
// ./src/api/blog.js